import React from 'react';
import { columns, exportHeaders, exportBlankFields } from './columns/index';
import { StyledContainer, StyledStockTable } from './styles';
import { FORM_SEARCH, searchDefaultValues } from './forms';
import { TextLarge, CardTheme, ButtonTheme } from '../../../components/index';
import { color, Icon } from '../../../resources';
import ButtonExcelEmbedded from '../../../components/report-excel/ButtonExcelEmbedded';
import { ContainerButton } from '../../../styles/global-style';
import { useEffect, useState } from 'preact/hooks';
import { ROUTES_PATH } from '../../../resources/routes-name';
import { navigateTo } from '../../../utils/navigation';
import { useClaimList } from './hooks/useClaimList';
import { useForm } from 'react-hook-form';
import { ResponsivePageLayout } from '../../../components/page-layout/ResponsivePageLayout';
import { useModal } from '../../../components/modal/hooks/useModal';
import { ModalMessage } from './modal/onModalMessage';
import { ProcessStatus } from './modal/ProcessStatus';
import { Button, Modal, Spin } from 'antd';
import { Gap } from '../../../components/space';
import { useApproveClaim } from './hooks/useApproveClaim';
import { Remark } from './modal/Remark';
import { useAntDModalContext } from '@/components/modal/context/useAntdModalContext';
import { useGetPDF } from './pdfPage/hooks/useGetPDF';
import { CustomImage } from '@/functions/Image';
import { SpaceBetweenShowInfo } from '../../manage-data/user-info/styles';
import { RowSearchLayout } from '../../../components/page-layout/views/RowSearchLayout';
import { InfoClaimProcessStatus } from './views/InfoClaimProcessStatus';
import { InfoClaimStatus } from './views/InfoClaimStatus';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { useGetClaimFull } from './hooks/useGetClaimFull';
import { useResendRequest } from '../claim-detail/hooks/useResendRequest';
import { ResendRequestModal } from '../claim-detail/modal/ResendRequestModal';
import {
  canResendCs,
  useHasResendCsPrivilege,
  useResendCs,
} from '../claim-detail/hooks/useResendCs';
import { getSendCsLabel } from '../shared/sendCsStatus';
import { useRevertReject } from './hooks/useRevertReject';
import { ChangeTrackNumber } from './modal/ChangeTrackNumber';
import { useSelector } from 'react-redux';
import { useStockAvailability } from './hooks/useStockAvailability';
import {
  dropOverSelectedKeys,
  getRowStockState,
  getStockExportFields,
  summarizeSelection,
} from './func/stockHelper';
import { STOCK_ROW_CLASS } from './resource/stockConst';
import { StockSelectionAlert } from './views/StockSelectionAlert';
import { ClaimCountLegend } from '../shared/claimCountIcon';
import { CustomerHistoryModal } from '../../../components/customer-history';
import { BulkSendLineMessage } from './modal/BulkSendLineMessage';

const resolveColumnKey = (column) => column.key ?? column.dataIndex;

// คอลัมน์กรองกันเองด้วย onFilter เดิมอยู่แล้ว ใช้ค่าเดียวกันคำนวณแถวที่มองเห็นจริงบนตาราง
// ไม่งั้น Export จะได้ snapshot เก่าที่ไม่ตรงกับตัวกรอง/สต็อกล่าสุด
const applyColumnFilters = (rows, cols, filters) => {
  if (!filters) return rows;
  return (cols || []).reduce((acc, column) => {
    if (typeof column.onFilter !== 'function') return acc;
    const activeValues = filters[resolveColumnKey(column)];
    if (!activeValues || activeValues.length === 0) return acc;
    return acc.filter((record) => activeValues.some((value) => column.onFilter(value, record)));
  }, rows);
};

const applyColumnSorter = (rows, sorter) => {
  const activeSorter = Array.isArray(sorter) ? sorter[0] : sorter;
  const compareFn = activeSorter?.column?.sorter;
  if (typeof compareFn !== 'function' || !activeSorter.order) return rows;
  // ลบทิศทางลงในตัวเปรียบเทียบแทนการ reverse() หลัง sort เพราะ reverse()
  // สลับลำดับแถวที่ค่าเท่ากันด้วย ทำให้ผลต่างจากตารางจริงเมื่อเรียงลด
  const direction = activeSorter.order === 'descend' ? -1 : 1;
  return [...rows].sort((a, b) => direction * compareFn(a, b));
};

const getVisibleRows = (data, cols, filters, sorter) =>
  applyColumnSorter(applyColumnFilters(data || [], cols, filters), sorter);

export const ClaimProduct = () => {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [modalData, setModalData] = useState({});
  const [searchType, setSearchType] = useState(null);
  const { open: openMessage, onToggle: onToggleMessage } = useModal();
  const { open: openProcessStatus, onToggle: onToggleProcessStatus } = useModal();
  const { open: openRemark, onToggle: onToggleRemark } = useModal();
  const { open: openChangeTrackNumber, onToggle: onToggleChangeTrackNumber } = useModal();
  const { open: openHistory, onToggle: onToggleHistory } = useModal();
  const { open: openBulkSend, onToggle: onToggleBulkSend } = useModal();
  const [tableFilters, setTableFilters] = useState({});
  const [tableSorter, setTableSorter] = useState(null);
  // เพิ่มทุกครั้งที่ค้นหา/ล้างค่าใหม่ ใช้เป็น key รีเมาท์ตาราง ไม่งั้น filteredInfo/sortedInfo
  // ภายใน antd Table ที่ไม่ได้ควบคุมจะค้างค่าตัวกรอง/การเรียงเดิมจากการค้นหาครั้งก่อน
  const [tableResetKey, setTableResetKey] = useState(0);
  const location = useLocation();
  const [isInitialFetch, setIsInitialFetch] = useState(true);
  const formSearchObj = useForm({ defaultValues: searchDefaultValues || location.state });
  const searchParamState = formSearchObj.watch();
  const { handleSubmit } = formSearchObj;
  const [modal, modalContext] = Modal.useModal();
  const { openConfirmModal } = useAntDModalContext();
  const userProfile = useSelector((state) => state.authen.users);
  const { privilegeAbmType } = userProfile;

  const {
    onFetchFull,
    dataSource: dataFull,
    loading: isPendingFull,
  } = useGetClaimFull({
    handleSubmit: formSearchObj.handleSubmit,
  });

  const {
    data: dataSource,
    setData: setDataSource,
    loading: isLoading,
    setData: setEmployee,
    onFetch,
  } = useClaimList({ setSelectedRowKeys, searchParamState });

  const { mutate: onSubmitApproveClaim, isPending: isPendingApproveClaim } = useApproveClaim({
    modal,
    selectedRowKeys,
    setEmployee,
    onSuccessCallback: () => {
      searchType === 'search' ? onFetchFull() : onFetch();
      // อนุมัติแล้วยอดจองเปลี่ยน ต้องดึงสต็อกใหม่ให้ตัวเลขตรง
      onFetchStock();
    },
  });

  const { mutate: fetchClaimPDF, isPending: isPendingFetchPDF } = useGetPDF();

  const { startResend, isPending: isPendingResendCs } = useResendCs({
    modal,
    onSuccess: () => {
      searchType === 'search' ? onFetchFull() : onFetch();
    },
  });

  const resendRequest = useResendRequest({
    onSuccess: () => {
      searchType === 'search' ? onFetchFull() : onFetch();
    },
  });

  // ไม่มีสิทธิ์ PE212 ไม่ส่ง handler ไป เมนูขอเลขเอกสาร CS จะไม่แสดง
  const hasResendCsPrivilege = useHasResendCsPrivilege();
  const onResendCs = hasResendCsPrivilege ? (record) => startResend([record.claimId]) : null;

  const { mutate: revertReject, isPending: isPendingRevertReject } = useRevertReject({
    onSuccess: () => {
      searchType === 'search' ? onFetchFull() : onFetch();
      modal.success({
        title: 'ถอยสถานะเรียบร้อย',
        content: 'รายการเคลมกลับเป็นสถานะรอตรวจสอบแล้ว',
        okText: 'ตกลง',
      });
    },
  });

  const onRevertReject = (record) => {
    modal.confirm({
      title: 'ถอยสถานะเป็นรอตรวจสอบ?',
      content: `เลขที่เคลม ${record.claimCode} จะกลับเป็นสถานะรอตรวจสอบ และล้างเหตุผลการไม่อนุมัติ`,
      okText: 'ยืนยัน',
      cancelText: 'ยกเลิก',
      onOk: () => revertReject({ claimId: record.claimId }),
    });
  };

  const tableDataSource = searchType === 'search' ? dataFull : dataSource;
  const {
    stockMap,
    meta: stockMeta,
    unavailable: isStockUnavailable,
    onFetchStock,
  } = useStockAvailability(tableDataSource);

  // สรุปว่าที่ติ๊กอยู่ตอนนี้เกินสต็อกหรือยัง คำนวณใหม่ทุกครั้งที่เลือก จะได้เห็นก่อนกดส่ง
  const { selectedByItem, overItems, overRowKeys } = summarizeSelection({
    dataSource: tableDataSource,
    selectedRowKeys,
    stockMap,
  });

  // สต็อกเป็นข้อมูลประกอบอย่างเดียว ไม่ล็อกการทำงาน
  // ผู้ใช้กดเลือก เปลี่ยนสถานะ อนุมัติ และออกใบส่งสินค้าได้เสมอ แม้ของไม่พอ

  const onRemoveOverSelected = () => {
    setSelectedRowKeys((prev) => dropOverSelectedKeys(prev, overRowKeys));
  };

  const handleSubmitAccident = () => {
    const selectedClaims =
      tableDataSource?.filter((claim) => selectedRowKeys.includes(claim.claimId)) || [];
    if (selectedClaims.some((claim) => claim.noDeductWarranty === 'Y')) {
      modal.warning({
        title: 'เคลมไม่หักประกันต้องอนุมัติในเมนู อนุมัติ > ไม่ตัดประกัน',
        okText: 'ตกลง',
      });
      return;
    }
    handleSubmit(() => onSubmitApproveClaim())();
  };

  const onSelectChange = (newSelectedRowKeys) => {
    const noDeductIds = new Set(
      (tableDataSource || [])
        .filter((claim) => claim.noDeductWarranty === 'Y')
        .map((claim) => claim.claimId),
    );
    setSelectedRowKeys(newSelectedRowKeys.filter((claimId) => !noDeductIds.has(claimId)));
  };

  const onModalMessage = (record) => {
    setModalData(record);
    onToggleMessage({ record });
  };

  const onModalProcessStatus = (record) => {
    setModalData(record);
    onToggleProcessStatus({ defaultValues: record });
  };

  const onModalRemark = (record) => {
    setModalData(record);
    onToggleRemark({ record });
  };

  const onModalChangeTrackNumber = (record) => {
    setModalData(record);
    onToggleChangeTrackNumber({ record });
  };

  const onShowHistory = (record) => {
    setModalData(record);
    onToggleHistory({ record });
  };

  const gotoPdfClaim = () => {
    if (selectedRowKeys.length > 0) {
      fetchClaimPDF(selectedRowKeys, {
        onSuccess: (pdfData) => {
          navigateTo({
            pathname: ROUTES_PATH.ROUTE_PDF_CLAIM.PATH,
            state: { pdfData: pdfData.result.items },
          });
        },
      });
    }
  };

  const gotoClaimCreate = () => {
    navigateTo({ pathname: ROUTES_PATH.ROUTE_CREATE_CLAIM.PATH });
  };

  useEffect(() => {
    if (location.state && isInitialFetch) {
      formSearchObj.handleSubmit(onFetch)();
      setIsInitialFetch(false);
    } else {
      onFetch(searchDefaultValues);
    }
  }, [location.state, isInitialFetch]);

  const resetTableFiltersAndSorter = () => {
    setTableFilters({});
    setTableSorter(null);
    setTableResetKey((prev) => prev + 1);
  };

  const onSearchByField = (values) => {
    resetTableFiltersAndSorter();
    if (values.search) {
      setSearchType('search');
      onFetchFull(values);
    } else if (values.startDate) {
      setSearchType('date');
      onFetch(values);
    }
  };

  // สร้างแถว Excel จาก exportHeaders โดยตรง คอลัมน์ที่แบรนด์นี้ไม่มีข้อมูลจะเว้นว่าง
  // สต็อกคำนวณจาก stockMap ชุดเดียวกับที่ตารางใช้ ณ ตอนกด export
  const transformDataForExcel = (data) =>
    (data ?? []).map((item) => {
      // ป้ายส่ง CS ให้ตรงกับที่ตารางแสดง (ไม่ใช้ sendCsStatusLabel จาก API)
      const row = {
        ...item,
        ...getStockExportFields(item, stockMap),
        sendCsStatusLabel: getSendCsLabel(item),
      };
      return Object.fromEntries(
        exportHeaders.map(({ dataIndex }) => [
          dataIndex,
          exportBlankFields.includes(dataIndex) ? '' : row?.[dataIndex] ?? '',
        ]),
      );
    });

  const formSearch = FORM_SEARCH({
    onEnter: formSearchObj.handleSubmit(onSearchByField),
    selectedRange: searchParamState.startDate,
  });

  const onTableChange = (_pagination, filters, sorter) => {
    setTableFilters(filters || {});
    setTableSorter(sorter || null);
  };

  const tableColumns = columns({
    onModalMessage,
    onModalProcessStatus,
    onModalRemark,
    onModalChangeTrackNumber,
    onResendCs,
    onResendRequest: resendRequest.openRequest,
    isPendingResendRequest: resendRequest.isPending,
    isPendingResendCs,
    onRevertReject,
    isPendingRevertReject,
    onShowHistory,
    privilegeAbmType,
    stockMap,
    selectedByItem,
  });

  const visibleRows = getVisibleRows(tableDataSource, tableColumns, tableFilters, tableSorter);

  const selectableVisibleRowKeys = visibleRows
    .filter((claim) => claim.noDeductWarranty !== 'Y')
    .map((claim) => claim.claimId);

  const onSelectAllFiltered = () => {
    setSelectedRowKeys(selectableVisibleRowKeys);
  };

  // ขอเลขเอกสาร CS รวดเดียว เฉพาะรายการที่เลือกและขอเลขได้ ที่เหลือข้ามไป
  const resendCsSelectedIds = (tableDataSource || [])
    .filter((claim) => selectedRowKeys.includes(claim.claimId) && canResendCs(claim))
    .map((claim) => claim.claimId);

  return (
    <StyledContainer>
      <TextLarge text="การเคลมสินค้า" />
      <CardTheme>
        <ContainerButton right>
          {privilegeAbmType !== 'READ' && (
            <ButtonTheme
              useFor="WARRANTY"
              title="ยื่นเรื่องเคลม"
              onClick={() => gotoClaimCreate()}
            />
          )}
          {privilegeAbmType !== 'READ' &&
            (isPendingApproveClaim ? (
              <Spin spinning={isPendingApproveClaim}></Spin>
            ) : (
              <ButtonTheme
                useFor="REGISTER"
                title="อนุมัติเรื่องเคลม"
                customBgColor={color.line}
                onClick={() => openConfirmModal({ onOk: handleSubmitAccident })}
                disabled={selectedRowKeys.length === 0}
                style={{ marginBottom: '30px' }}
              />
            ))}
          {privilegeAbmType !== 'READ' &&
            (isPendingFetchPDF ? (
              <Spin spinning={isPendingFetchPDF}></Spin>
            ) : (
              <ButtonTheme
                useFor="REGISTER"
                title="ใบส่งสินค้า"
                customBgColor={color.search2}
                onClick={() => gotoPdfClaim()}
                disabled={selectedRowKeys.length === 0}
              />
            ))}
          {privilegeAbmType !== 'READ' && (
            <ButtonTheme
              useFor="LINE"
              title="ส่งข้อความ LINE"
              onClick={onToggleBulkSend}
              disabled={selectedRowKeys.length === 0}
            />
          )}
          {privilegeAbmType !== 'READ' &&
            hasResendCsPrivilege &&
            (isPendingResendCs ? (
              <Spin spinning={isPendingResendCs}></Spin>
            ) : (
              <ButtonTheme
                useFor="REGISTER"
                title={`ขอเลขเอกสาร CS (${resendCsSelectedIds.length})`}
                customBgColor={color.search2}
                onClick={() => startResend(resendCsSelectedIds)}
                disabled={resendCsSelectedIds.length === 0}
              />
            ))}
        </ContainerButton>
        <RowSearchLayout
          props={{
            title: 'ค้นหาการเคลมสินค้า',
            formSearch,
            useFormParam: formSearchObj,
            icon: <Icon.todo />,
            onSearch: formSearchObj.handleSubmit(onSearchByField),
            onClearCustom: () => {
              formSearchObj.reset(searchDefaultValues);
              setDataSource([]);
              setSelectedRowKeys([]);
              setEmployee([]);
              resetTableFiltersAndSorter();
            },
          }}
        >
          <div style={{ display: 'flex', width: '100%' }}>
            <div style={{ flex: 1, paddingRight: '8px' }}>
              <InfoClaimStatus />
            </div>
            <div style={{ flex: 1, paddingLeft: '8px' }}>
              <InfoClaimProcessStatus />
            </div>
          </div>
          <div style={{ marginTop: '8px' }}>
            <ClaimCountLegend framed={false} />
          </div>
        </RowSearchLayout>
        <StyledStockTable>
          <ResponsivePageLayout
            key={tableResetKey}
            tableLayout={{
              columns: tableColumns,
              dataSource: tableDataSource,
              // ไม่ตั้ง scroll.x เอง ให้ TableComponent รวมความกว้างจากคอลัมน์ให้
              // 'max-content' ทำให้ตารางว่างหดจนหัวคอลัมน์ตัดคำเป็นแนวตั้ง
              hasPagination: true,
              loading: isLoading || isPendingFull,
              rowKey: 'claimId',
              onChange: onTableChange,
              extraContent: (
                <StockSelectionAlert
                  unavailable={isStockUnavailable}
                  overItems={overItems}
                  selectedCount={selectedRowKeys.length}
                  staleMinutes={stockMeta.staleMinutes}
                  onRemoveOverSelected={onRemoveOverSelected}
                />
              ),
              rowClassName: (record) => {
                const { state } = getRowStockState({ record, stockMap, selectedByItem });
                return STOCK_ROW_CLASS[state] ?? '';
              },
              rowSelection: {
                selectedRowKeys,
                onChange: onSelectChange,
                getCheckboxProps: (record) => ({
                  disabled: record.noDeductWarranty === 'Y',
                  title:
                    record.noDeductWarranty === 'Y'
                      ? 'อนุมัติในเมนู อนุมัติ > ไม่ตัดประกัน'
                      : undefined,
                }),
              },
              expandable: {
                expandedRowRender: (record) => (
                  <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
                    <CustomImage
                      width={80}
                      preview
                      src={record.claimImageUrl}
                      style={{ borderRadius: 8 }}
                    />
                    <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '20px' }}>
                      <div style={{ marginBottom: '8px' }}>
                        <strong>ชื่อสินค้า: </strong>
                        {record.productName}
                      </div>
                      <div style={{ marginBottom: '8px' }}>
                        <strong>รุ่นมือถือ: </strong>
                        {record.mobileModelName}
                      </div>
                      <div>
                        <strong>อาการเสีย: </strong>
                        {record.breakdownName}
                      </div>
                    </div>
                  </div>
                ),
                rowExpandable: (record) => record.name !== 'Not Expandable',
              },
              extraContent: (
                <SpaceBetweenShowInfo>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                    <div>
                      {selectedRowKeys.length > 0
                        ? `เลือก ${selectedRowKeys.length} รายการ`
                        : 'ยังไม่ได้เลือกรายการ'}
                    </div>
                    <Button
                      type="link"
                      onClick={onSelectAllFiltered}
                      disabled={selectableVisibleRowKeys.length === 0}
                      style={{ padding: 0 }}
                    >
                      {`เลือกทั้งหมดที่กรอง (${selectableVisibleRowKeys.length})`}
                    </Button>
                  </div>
                  <ButtonExcelEmbedded
                    title={`Export (${visibleRows.length})`}
                    header={exportHeaders}
                    data={transformDataForExcel(visibleRows)}
                    filename="รายงานการเคลมสินค้า"
                  />
                </SpaceBetweenShowInfo>
              ),
            }}
          />
        </StyledStockTable>
      </CardTheme>
      {openMessage && (
        <ModalMessage open={openMessage} onToggle={onToggleMessage} initialValues={modalData} />
      )}
      {openBulkSend && (
        <BulkSendLineMessage
          open={openBulkSend}
          onToggle={onToggleBulkSend}
          modal={modal}
          selectedClaims={
            tableDataSource?.filter((claim) => selectedRowKeys.includes(claim.claimId)) || []
          }
        />
      )}
      {openProcessStatus && (
        <ProcessStatus
          open={openProcessStatus}
          onToggle={onToggleProcessStatus}
          initialValues={modalData}
          onFetch={onFetch}
        />
      )}
      {openRemark && (
        <Remark open={openRemark} onToggle={onToggleRemark} initialValues={modalData} />
      )}
      {openChangeTrackNumber && (
        <ChangeTrackNumber
          open={openChangeTrackNumber}
          onToggle={onToggleChangeTrackNumber}
          initialValues={modalData}
          onFetch={onFetch}
        />
      )}
      {openHistory && (
        <CustomerHistoryModal
          open={openHistory}
          onToggle={onToggleHistory}
          initialValues={modalData}
        />
      )}
      {resendRequest.target && <ResendRequestModal request={resendRequest} />}
      {modalContext}
      <Gap />
    </StyledContainer>
  );
};
